export const uk = {
    pageHeader: 'Анкета специалиста: {fullName}',
    saveError: 'Не удалось обновить анкету, попробуйте позже.'
};
